(() => {
  'use strict';
  function calculate(variant, options = {}) {
    const price = Number(variant?.price);
    const compare = Number(variant?.compare_at_price);
    if (!variant || options.disabled || !Number.isSafeInteger(price) || price < 0 || !Number.isSafeInteger(compare) || compare <= price) return null;
    const order = options.scope === 'order';
    const quantity = order ? Number(options.quantity ?? 1) : 1;
    const divisor = order ? 1 : Number(options.divisor ?? 1);
    if (!Number.isSafeInteger(quantity) || quantity < 1 || !Number.isSafeInteger(divisor) || divisor < 1) return null;
    const saving = (compare - price) * quantity;
    const base = order ? Number(options.total ?? price * quantity) : price;
    if (!Number.isSafeInteger(base) || base < price * quantity || !Number.isSafeInteger(saving)) return null;
    const reference = base + saving;
    return { compare: Math.round(reference / divisor), current: Math.round(base / divisor), saving, percent: Math.floor(saving * 100 / reference) };
  }
  function update(root, variant, options = {}) {
    const currency = options.currency || window.Shopify?.currency?.active || 'USD';
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format(cents / 100);
    let onSale = false;
    root.querySelectorAll('[data-vp-sale-note]').forEach(note => {
      const result = calculate(variant, { ...options, scope: note.dataset.saleScope, divisor: options.divisor ?? Number(note.dataset.saleDivisor) });
      note.hidden = !result;
      if (!result) return;
      onSale = true;
      note.querySelector('[data-vp-sale-regular]').hidden = result.compare <= result.current;
      note.querySelector('[data-vp-sale-compare]').textContent = money(result.compare);
      note.querySelector('[data-vp-sale-saving]').textContent = note.dataset.saleSavingFormat.replace('__AMOUNT__', money(result.saving));
      note.querySelector('[data-vp-sale-percent]').textContent = note.dataset.salePercentFormat.replace('__PERCENT__', String(result.percent));
    });
    root.dataset.vpOnSale = String(onSale);
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { calculate };
  if (typeof window !== 'undefined' && !window.VaraprintSalePrices) window.VaraprintSalePrices = { update };
})();
